import apiClient from '../apiClient';
import { GET_CUSTOM_ENUM_BY_CATAGORIES } from '../apiUrl';

const getCustomEnumByCatagoriesTotaEmployeApi = () => {
  return apiClient.get(GET_CUSTOM_ENUM_BY_CATAGORIES('TOTAL_EMPLOYEE'));
};

export default getCustomEnumByCatagoriesTotaEmployeApi;
